import { RecursiveObject } from '@chakra-ui/react';

export const fontSizes: RecursiveObject = {
  // The design system is inconsistent between figma and the code
  cookieConsent: '0.75rem',
  xs: '0.8125rem',
  xxs: '0.625rem',
  '4xl': '2rem'
};
